// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React from 'react';
import { Grid } from '@material-ui/core';
import { bool } from 'prop-types';

import { FormTextField, FormSelect } from '../../../components';
import {
  RATE_QUOTAS_LIST_LIMITS,
  RATE_QUOTAS_LIST_SORT_BY,
  RATE_QUOTAS_LIST_LEVELS_WITH_PRODUCTS,
} from '../../../constants';

export const FilterByName = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormTextField
      {...props}
      id="rate-quote-filter-by-name"
      data-apim-test="rate-quote-filter-by-name"
    />
  </Grid>
);

export const FilterByLevels = (props) => (
  <Grid item md={2} sm={3} xs={12}>
    <FormSelect
      {...props}
      id="rate-quote-filter-by-level"
      data-apim-test="rate-quote-filter-by-level"
      data={RATE_QUOTAS_LIST_LEVELS_WITH_PRODUCTS}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterByLimit = (props) => {
  const data = props.featureFlagDistributeRateLimit ? RATE_QUOTAS_LIST_LIMITS :
  RATE_QUOTAS_LIST_LIMITS.filter((obj) => obj.uuid !== 'distributerate') ;
  return (
    <Grid item md={2} sm={3} xs={12}>
      <FormSelect
        {...props}
        id="rate-quote-filter-by-limit"
        data-apim-test="rate-quote-filter-by-limit"
        data={data}
        noNoneOption
        noNativeSelect
      />
    </Grid>
  );
}

FilterByLimit.propTypes = {
  featureFlagDistributeRateLimit: bool,
};

export const SortBy = (props) => (
  <Grid item md={3} sm={3} xs={12}>
    <FormSelect
      {...props}
      id="rate-quote-sort-by"
      data-apim-test="rate-quote-sort-by"
      data={RATE_QUOTAS_LIST_SORT_BY}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);

export const FilterAndSortSeparator = () => (
  <Grid item md={1} />
);
